import { unref, ref } from 'vue'

// Error elements array: [{ [errorName]: HTMLElement }, ... ]
const errElements = ref({})

export default function (validationErrors) {
  function scrollToError() {
    const errors = unref(validationErrors)
    const errNames = Object.keys(errElements.value).filter(
      (x) => errors[x]?.length
    )

    if (!errNames.length) return

    let el = null
    let minTop = document.documentElement.scrollHeight
    for (const name of errNames) {
      const curEl = errElements.value[name]
      const elTop = curEl.getBoundingClientRect().top
      if (elTop < minTop) {
        minTop = elTop
        el = curEl
      }
    }

    el.scrollIntoView()
  }

  function updateErrRef(value, errName) {
    if (value) errElements.value[errName] = value.$el
  }

  return {
    scrollToError,
    updateErrRef,
  }
}
